module.exports = __webpack_public_path__ + "img/mine-menu8.9083002f.png";